<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">岗位名称</label>
            <em class="weui-form-preview__value">{{form.name}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">岗位描述</label>
            <div class="weui-form-preview__value">{{form.description}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/sys/role_edit?id='+form.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove"
      >删除</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/account/role",
    };
  },
};
</script>